import { useMemo } from 'react'
import { useStaticQuery } from 'gatsby'
import { get } from 'lodash'

export const FilterdFazendas = (prop, value) => {

  // const prop = ""
  // const value = "classic"

  const data = useStaticQuery(queryAllFazendas)
  const fazendas = get(data, 'prismic.allFazendas.edges') 

  const parsedFazendas = useMemo(() => {
    if (!fazendas) {
      return null
    }

    return fazendas.map((d) => {
      const node = d.node

      return {
        title: get(node, 'title'),
        _meta: get(node, '_meta'),
        slug: get(node, '_meta.uid'),
        intro: get(node, 'intro'),
        main_image: get(node, 'main_image'),
        local_location: get(node, 'local_location'),
        country: get(node, 'country'),
        country_uid: get(node, 'country._meta.uid'),
      }
    }).sort((a,b) => (a.slug < b.slug) ? 1 : ((b.slug < a.slug) ? -1 : 0))
  }, [fazendas])

  // console.log('[FilterdFazendas] parsedFazendas', parsedFazendas)

 
  const filterByProperty = (prop, value) => {

    // console.log('filter prop', prop)
    // console.log('filter value', value)

    let filteredArray = []
    for(var i = 0; i < parsedFazendas.length; i++){

      let obj = parsedFazendas[i]
      
      for(let key in obj){
        // console.log('filter obj', obj)

        if(typeof(obj[key] === "object")){
          // let item = obj;

          // console.log('filter obj[prop] ', obj[prop])
          
          if(obj[prop] === value){
            filteredArray.push(obj)
            break
          }
        }
      }
    }
    
    return filteredArray
  }

  return filterByProperty (prop, value)
}

const queryAllFazendas = graphql`
query allFazendas {
  prismic {
    allFazendas {
      edges {
        node {
          _meta {
            uid
            lang
            type
          }
          title
          main_image
          intro
          local_location
          country {
            ... on PRISMIC_Country {
              _meta {
                uid
                lang
                type
              }
              title
              flag
            }
          }
        }
      }
    }
  }
}
`